//@ts-check
//@ts-ignore
import Register from './register.riot';
import { connect } from '@/common/lib/riot-redux';
import { registerFailure, registerRequest, registerSuccess, registerUrlRequest, registerUrlSuccess, registerUrlFailure } from './register.action';
import { ajaxPost } from '../ajax';
import { router } from '@riotjs/route';

const mapDispatchToProps = (dispatch, props) => ({
  async register(data) {
    dispatch(registerRequest());
    try {
      await ajaxPost('/register', {
        method: 'register',
        mail: data.mail,
        officeName: data.officeName,
        shopName: data.shopName,
        shopTel: data.shopTel,
        numShop: data.numShop,
        shopType: data.shopType,
      });
      dispatch(registerSuccess());
      router.push('result');
    } catch (e) {
      dispatch(registerFailure(e));
    }
  },

  async registerUrl() {
    if (props.rKey == null) {
      return;
    }
    dispatch(registerUrlRequest());
    try {
      await ajaxPost('/register', {
        method: 'registerUrl',
        key: props.rKey
      });
      dispatch(registerUrlSuccess());
      router.push('result');
    } catch (e) {
      dispatch(registerUrlFailure(e));
    }
  }
});

export default connect(Register, null, mapDispatchToProps); 